import { render, staticRenderFns } from "./StickySideButton.vue?vue&type=template&id=6bdc410c&"
import script from "./StickySideButton.vue?vue&type=script&lang=js&"
export * from "./StickySideButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports